import React from "react";
import Carousel from "../components/Carousel";

/**
 * Put your images in /public/images/
 * Example:
 *  - public/images/car.png (the hero PNG that slides in)
 *  - public/images/bmw-1.jpg
 *  - public/images/bmw-2.jpg
 *  - public/images/bmw-3.jpg
 */
export default function Home() {
  const carouselImages = [
    "/images/bmw-1.jpg",
    "/images/bmw-2.jpg",
    "/images/bmw-3.jpg",
    "/images/bmw-4.jpg",
    "/images/bmw-5.jpg",
    "/images/bmw-6.jpg",
    "/images/bmw-7.jpg",
    "/images/bmw-8.jpg",
    "/images/bmw-9.jpg",
    "/images/bmw-10.jpg",
    "/images/bmw-11.jpg",
    "/images/bmw-12.jpg",
  ];

  return (
    <div className="mx-auto max-w-6xl px-4 pt-8 md:pt-10">
      {/* HERO */}
      <section className="relative overflow-hidden rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-[0_25px_70px_rgba(0,0,0,0.35)]">
        <div className="grid gap-10 px-6 py-10 md:grid-cols-2 md:px-10 md:py-14">
          <div className="relative">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-xs font-semibold text-white/80 ring-1 ring-white/10">
              <span className="inline-block h-2 w-2 rounded-full bg-emerald-400" />
              В наличност • 2024
            </div>

            <h1 className="mt-5 text-3xl font-extrabold tracking-tight md:text-5xl">
              <span className="text-white/80">АМ Рентал предлага</span>
              <br />
              <span className="bg-gradient-to-r from-white via-white to-white/70 bg-clip-text text-transparent">
                BMW X4 M Competition
              </span>
            </h1>

            <p className="mt-5 text-base leading-relaxed text-white/70">
              Предлагаме под наем BMW X4 M Competition 2024 – върхов клас спортен SUV с изключителна
              динамика, премиум комфорт и впечатляваща визуална идентичност.
            </p>

            <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="tel:+359999991948"
                className="inline-flex items-center justify-center rounded-2xl bg-white px-5 py-3 text-sm font-bold text-slate-950 hover:opacity-90 transition"
              >
                Обади се за резервация
              </a>
              <a
                href="#details"
                className="inline-flex items-center justify-center rounded-2xl bg-white/10 px-5 py-3 text-sm font-semibold text-white ring-1 ring-white/15 hover:bg-white/15 transition"
              >
                Виж детайли
              </a>
            </div>

            <div className="mt-7 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {[
                { k: "Мощност", v: "до 510 к.с." },
                { k: "0–100", v: "~3.8 сек." },
                { k: "Задвижване", v: "M xDrive 4x4" },
                { k: "Трансмисия", v: "8-степ." },
              ].map((x) => (
                <div
                  key={x.k}
                  className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3"
                >
                  <div className="text-xs text-white/60">{x.k}</div>
                  <div className="mt-1 text-sm font-semibold">{x.v}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Car PNG animation (right -> left) */}
          <div className="relative flex items-center justify-center">
            <div className="pointer-events-none absolute inset-0 rounded-3xl bg-gradient-to-tr from-blue-500/10 via-fuchsia-500/10 to-emerald-500/10 blur-2xl" />

            <img
              src="/images/main.png"
              alt="BMW X4 M Competition"
              className="w-full max-w-xl drop-shadow-[0_35px_70px_rgba(0,0,0,0.55)]
                         animate-carEnter"
            />

            {/* small floating badges */}
            <div className="absolute left-4 top-4 rounded-2xl bg-black/35 px-4 py-3 text-xs text-white/80 ring-1 ring-white/10">
              Премиум клас
            </div>
            <div className="absolute right-4 bottom-4 rounded-2xl bg-black/35 px-4 py-3 text-xs text-white/80 ring-1 ring-white/10">
              Цена: по договаряне
            </div>
          </div>
        </div>
      </section>

      {/* Carousel */}
      <section className="mt-10">
        <div className="mb-4 flex items-end justify-between gap-3">
          <div>
            <h2 className="text-xl font-bold">Галерия</h2>
            <p className="mt-1 text-sm text-white/60">Снимки на автомобила</p>
          </div>
        </div>
        <Carousel images={carouselImages} />
      </section>

      {/* Details */}
      <section id="details" className="mt-12 space-y-10">
        <div className="rounded-3xl border border-white/10 bg-white/5 p-6 md:p-8">
          <p className="text-white/70 leading-relaxed">
            Автомобилът е оборудван с мощен 3.0-литров редови 6-цилиндров двигател с до 510 к.с.,
            интелигентно 4x4 M xDrive задвижване и 8-скоростна автоматична Steptronic трансмисия,
            което осигурява спортно, стабилно и уверено шофиране.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          <div className="rounded-3xl border border-white/10 bg-white/5 p-6 md:p-8">
            <h3 className="text-lg font-bold">Основни характеристики и екстри</h3>
            <ul className="mt-4 space-y-3 text-sm text-white/70">
              <li><span className="font-semibold text-white">Мощност и динамика:</span> до 510 к.с., ускорение 0-100 км/ч в ~3.8 сек., максимална скорост електронно ограничена до 285км/ч.</li>
              <li><span className="font-semibold text-white">Задвижване:</span> адаптивен M xDrive AWD с режим за спортно каране.</li>
              <li><span className="font-semibold text-white">Системи за безопасност и асистенция:</span> адаптивен круиз контрол, асистент за поддържане на лента, сензори за мъртви зони, камери 360°, парктроник.</li>
              <li><span className="font-semibold text-white">Комфорт:</span> двузонов климатик, електрически регулирани и подгрявани седалки с памет, вентилация, KEYLESS GO система, сензор за дъжд и светлини.</li>
              <li><span className="font-semibold text-white">Инфотейнмънт:</span> голям сензорен дисплей с навигация (GPS), Apple CarPlay/Android Auto, премиум аудио система.</li>
              <li><span className="font-semibold text-white">Допълнителни екстри:</span> адаптивни LED фарове, head-up дисплей, Harman Kardon звук, автоматично затварящи се врати, електрически багажник.</li>
            </ul>
            <p className="mt-4 text-sm text-white/60">
              Забележка: автомобилът включва повечето стандартни и опционални екстри, с изключение на панорамен покрив и карбонови акценти.
            </p>
          </div>

          <div className="rounded-3xl border border-white/10 bg-white/5 p-6 md:p-8">
            <h3 className="text-lg font-bold">Кому е подходящо</h3>
            <p className="mt-4 text-sm text-white/70">Автомобилът е идеален за:</p>
            <ul className="mt-3 space-y-2 text-sm text-white/70">
              <li>• официални и корпоративни събития</li>
              <li>• рекламни и маркетингови дейности</li>
              <li>• лични изживявания и удоволствие от шофирането</li>
              <li>• фотосесии, видеопроизводство, VIP трансфери</li>
            </ul>

            <div className="mt-8 rounded-2xl border border-white/10 bg-black/20 p-5">
              <h4 className="font-semibold">Условия</h4>
              <div className="mt-2 text-sm text-white/70 space-y-1">
                <div><span className="text-white font-semibold">Цена:</span> по договаряне</div>
                <div><span className="text-white font-semibold">Срокове:</span> по договаряне</div>
              </div>

              <a
                href="tel:+359999991948"
                className="mt-4 inline-flex w-full items-center justify-center rounded-2xl bg-white px-5 py-3 text-sm font-bold text-slate-950 hover:opacity-90 transition"
              >
                За наличности и резервации: +359 999 99 1948
              </a>
            </div>
          </div>
        </div>
      </section>

      <div className="h-16" />
    </div>
  );
}
